import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Info = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12ZM3.25 12C3.25 7.18 7.17 3.25 12 3.25C16.83 3.25 20.75 7.18 20.75 12C20.75 16.82 16.83 20.75 12 20.75C7.17 20.75 3.25 16.82 3.25 12ZM12.0001 7.88C12.5192 7.88 12.9401 7.45915 12.9401 6.94C12.9401 6.42085 12.5192 6 12.0001 6C11.4809 6 11.0601 6.42085 11.0601 6.94C11.0601 7.45915 11.4809 7.88 12.0001 7.88ZM12 17.6101C11.66 17.6101 11.38 17.3301 11.38 16.9901V9.7201C11.38 9.3701 11.66 9.1001 12 9.1001C12.34 9.1001 12.62 9.3801 12.62 9.7201V16.9901C12.62 17.3401 12.34 17.6101 12 17.6101Z"
    />
  </svg>
)

export default withDefaultStyles(Info)
